// Determine if we're in development mode
const isDevelopment =
  process.env.NODE_ENV === "development" ||
  process.env.REACT_APP_ENV === "development" ||
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const config = {
  eloxOrange: "rgb(253,79,3)",
  azureFunctionUrlDev: "http://localhost:7071/api",
  azureFunctionUrlProd:
    "https://func-beitsapp-prod-abang0abchfka5gz.westeurope-01.azurewebsites.net/api",
  // Automatically use development URL when in dev mode, otherwise use production URL
  azureFunctionUrl: isDevelopment
    ? "http://localhost:7071/api"
    : "https://beitsapp-api.aucto.nl/api",
  azureFunctionHostKey:
    "cM6sKH1xCO0bbL7qRfGjUfBq6D_2UO7Fr3saDchs0wdJAzFuT3vf-w==",
  // Add development mode flag for debugging
  isDevelopment,
};

export default config;
